import { facilityStayAction } from '../../actions/constant';

const {
  SUCCESS_GET_ALL_FACILITIES,
  FAILURE_GET_ALL_FACILITIES,
  RESET_GET_ALL_FACILITIES,
  CREATE_FACILITIES_LOADING,
} = facilityStayAction;

const initialState: any = {
  getAllFacilities: false,
  response: null,
  loading: false,
  totalFacility: [],
  currentPage: -1,
  pageNumber: 0,
};

export const getAllFaciltiesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_FACILITIES: {
      const newPageNumber = action.payload?.data?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          getAllFacilities: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: [...state.totalFacility, ...action.payload?.data?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          getAllFacilities: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: action.payload?.data?.data?.content || [],
        };
      }
    }

    case FAILURE_GET_ALL_FACILITIES:
      return {
        ...state,
        getAllFacilities: false,
        response: action.payload,
        loading: false,
      };

    case CREATE_FACILITIES_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_GET_ALL_FACILITIES:
      return initialState;

    default:
      return state;
  }
};
